<template>
    <warning-alert>
        If you download a document that contains someone's Protected Health Information, 
        you are responsible for securing the information and protecting it from access 
        by unauthorized entities. The Application Funding Portal should not be used as a 
        record storage device. Please download copies of any documents you need for your 
        own records.
    </warning-alert>
</template>
 